"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListFileProcessorPatterns = void 0;
var ListFileProcessorPatterns;
(function (ListFileProcessorPatterns) {
    ListFileProcessorPatterns["Process"] = "Process";
})(ListFileProcessorPatterns = exports.ListFileProcessorPatterns || (exports.ListFileProcessorPatterns = {}));
